import { createSelector, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { authExtraReducers } from '@store/reducres/auth.reducers'

export const authUrl = ''

export interface UserModel {
  username: string
  email: string
  ttl: string
}

export interface AuthState {
  user: UserModel | null
  loading: boolean
  error: string | null
}

const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: authExtraReducers,
})

export default authSlice.reducer
